const TAG_CLASSES: Record<string, string> = {
  NIS2: "tag-nis2",
  DORA: "tag-dora",
  DSGVO: "tag-dsgvo",
  CRA: "tag-cra",
  "AI-Act": "tag-aiact",
  eIDAS: "tag-eidas",
  MiCA: "tag-mica",
  BSI: "tag-bsi",
  ENISA: "tag-enisa",
  EBA: "tag-eba",
  EZB: "tag-ezb",
  Warnung: "tag-warnung",
};

interface TagBadgeProps {
  tag: string;
  small?: boolean;
  onClick?: () => void;
}

export function TagBadge({ tag, small, onClick }: TagBadgeProps) {
  const cls = TAG_CLASSES[tag] || "tag-default";
  return (
    <span
      className={`tag ${cls}${small ? " tag-sm" : ""}${onClick ? " tag-clickable" : ""}`}
      onClick={onClick}
    >
      {tag}
    </span>
  );
}
